import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import '../css/navbar_component.css';

const menuVariants = {
    hidden: { opacity: 0, x: '100%' },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            when: 'beforeChildren',
            staggerChildren: 0.1,
        },
    },
    exit: {
        x: '100%',
        transition: { duration: 0.2 },
    },
};

function NavigationProvider() {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    const discordId = Cookies.get('discord_id');
    const avatarHash = Cookies.get('avatar');
    const avatarUrl = discordId && avatarHash
        ? `https://cdn.discordapp.com/avatars/${discordId}/${avatarHash}.png?size=32`
        : null;

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
            setIsOpen(false);
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') setIsOpen(false);
        };
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('keydown', handleEscape);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            setIsOpen(false);
        }
    };

    const REACT_APP_API_DISCORD_OAUTH_PAGE=process.env.REACT_APP_API_DISCORD_OAUTH_PAGE;
    const navItems = [
        { label: 'Home', path: '/' },
        { label: 'Documentation', path: '/documentation' },
        { label: 'Applications', path: '/apply' },
        { label: 'Items', path: '/items' },
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Sign In', path: `${REACT_APP_API_DISCORD_OAUTH_PAGE}` },
    ];

    return (
        <nav className={`nav-bar ${scrolled ? 'scrolled' : ''}`}>
            <div className="nav-content">
                <div className="logo">
                    <img src="https://cdn.ballhead.app/web_assets/logo.png" alt="Ballhead Logo" className="logo-image" />
                </div>
                <div className="desktop-links">
                    {navItems.map(item => {
                        if (item.label === 'Sign In' && avatarUrl) {
                            return (
                                <img src={avatarUrl} alt="Profile" className="nav-avatar"/>
                            )
                        }

                        if (item.label === 'Sign In') {
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`nav-button ${location.pathname === item.path ? 'active' : ''}`}
                                >
                                    {item.label}
                                </Link>
                            );
                        }
                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`nav-button ${location.pathname === item.path ? 'active' : ''}`}
                            >
                                {item.label}
                            </Link>
                        );
                    })}
                </div>
                <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
                    <span className={`hamburger-icon ${isOpen ? 'open' : ''}`}></span>
                </button>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="mobile-overlay"
                        onClick={handleOverlayClick}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="mobile-menu"
                            variants={menuVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <div className="mobile-header">
                                <div className="logo">
                                    <img src="https://cdn.ballhead.app/web_assets/logo.png" alt="Ballhead Logo" className="logo-image" />
                                </div>
                                <button className="close-btn" onClick={() => setIsOpen(false)}>
                                    ✕
                                </button>
                            </div>
                            <div className="mobile-links">
                                {navItems.map(item => (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        className={`mobile-button ${location.pathname === item.path ? 'active' : ''}`}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        {item.label}
                                    </Link>
                                ))}
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </nav>
    );
}

export default NavigationProvider;
